/**
 * Centralized configuration for Vara animated fonts
 * Change the SELECTED_FONT to switch fonts across the entire app
 */

export type VaraFontName = "satisfy" | "pacifico" | "parisienne" | "shadows-into-light";

export interface VaraFontConfig {
  name: string;
  url: string;
  description: string;
  strokeWidth?: number;
}

export const VARA_FONTS: Record<VaraFontName, VaraFontConfig> = {
  satisfy: {
    name: "Satisfy",
    url: "https://cdn.jsdelivr.net/npm/vara@1.4.0/fonts/Satisfy/SatisfySL.json",
    description: "Elegant, flowing script",
    strokeWidth: 2, // Increased for bolder appearance (default is 0.8)
  },
  pacifico: {
    name: "Pacifico",
    url: "https://cdn.jsdelivr.net/npm/vara@1.4.0/fonts/Pacifico/PacificoSLO.json",
    description: "Bold, casual brush script",
    strokeWidth: 0.8,
  },
  parisienne: {
    name: "Parisienne",
    url: "https://cdn.jsdelivr.net/npm/vara@1.4.0/fonts/Parisienne/Parisienne.json",
    description: "Elegant, formal calligraphy",
    strokeWidth: 0.8,
  },
  "shadows-into-light": {
    name: "Shadows Into Light",
    url: "https://cdn.jsdelivr.net/npm/vara@1.4.0/fonts/Shadows-Into-Light/shadows-into-light.json",
    description: "Casual, handwritten style",
    strokeWidth: 0.8,
  },
};

/**
 * CENTRALIZED FONT SELECTION
 * Change this value to switch fonts across the entire application:
 * - "satisfy" - Elegant, flowing script
 * - "pacifico" - Bold, casual brush script
 * - "parisienne" - Elegant, formal calligraphy (currently selected)
 * - "shadows-into-light" - Casual, handwritten style
 */
export const SELECTED_FONT: VaraFontName = "satisfy";

/**
 * Get the currently selected font configuration
 */
export function getSelectedFont(): VaraFontConfig {
  return VARA_FONTS[SELECTED_FONT];
}

/**
 * Get the URL of the currently selected font
 */
export function getSelectedFontUrl(): string {
  return VARA_FONTS[SELECTED_FONT].url;
}

/**
 * Get the stroke width of the currently selected font
 */
export function getSelectedFontStrokeWidth(): number {
  return VARA_FONTS[SELECTED_FONT].strokeWidth ?? 0.8;
}
